"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
var preact_1 = require("preact");
var preact_router_1 = require("preact-router");
var decko_1 = require("decko");
var SearchBar = (function (_super) {
    __extends(SearchBar, _super);
    function SearchBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchBar.prototype.onSearchButtonMount = function (input) {
        this._searchInput = input;
    };
    SearchBar.prototype.performSearch = function () {
        (0, preact_router_1.route)("/search?q=".concat(encodeURIComponent(this._searchInput.value)), !!this.props.useHistoryReplace);
    };
    SearchBar.prototype.render = function () {
        return ((0, preact_1.h)("div", null,
            (0, preact_1.h)("input", { type: "search", ref: this.onSearchButtonMount, value: this.props.text || '' }),
            (0, preact_1.h)("button", { onClick: this.performSearch }, "Search")));
    };
    __decorate([
        decko_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [HTMLInputElement]),
        __metadata("design:returntype", void 0)
    ], SearchBar.prototype, "onSearchButtonMount", null);
    __decorate([
        decko_1.bind,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SearchBar.prototype, "performSearch", null);
    return SearchBar;
}(preact_1.Component));
exports.SearchBar = SearchBar;
